<div class="main-container">
  <h2><b>{{'pre-interview-questions.header' | translate }}</b></h2>
  <p>{{'pre-interview-questions.header-description' | translate }}</p>

  <hr>

  <app-pre-interview-questions-view *ngIf="pageState === 'view'"
                                    [staticQuestionsList]="staticQuestionsList"
                                    [customQuestionsList]="customQuestionsList"
                                    [activeQuestionCount]="activeQuestionCount"
                                    [aiQuestionsList]="aiQuestionsList">
  </app-pre-interview-questions-view>

  <app-pre-interview-questions-edit *ngIf="pageState === 'edit'"
                                    [orderId]="orderId"
                                    [agentId]="agentId"
                                    [staticQuestionsList]="staticQuestionsList"
                                    [customQuestionsList]="customQuestionsList"
                                    [activeQuestionCount]="activeQuestionCount"
                                    [aiQuestionsList]="aiQuestionsList">
  </app-pre-interview-questions-edit>
</div>
